import type { HelpFile } from '../../types/help'
import { DelegationFormDialogTestIds } from '../../../testids/DelegationFormDialogTestIds'

export const delegationFormDialogHelp: HelpFile = {
  docPage: '/docs/my-iam/delegations',
  texts: {
    [DelegationFormDialogTestIds.deputyCombobox]:
      'Vertretungen suchen, die die delegierte Genehmigungsbefugnis erhalten.',
    [DelegationFormDialogTestIds.selectedDeputies]: null,
    [DelegationFormDialogTestIds.startDateInput]:
      'Datum, ab dem die Delegierung gilt.',
    [DelegationFormDialogTestIds.endDateInput]:
      'Datum, an dem die Delegierung endet — leer lassen für eine dauerhafte Delegierung.',
    [DelegationFormDialogTestIds.permanentSwitch]:
      'Delegierung dauerhaft ohne Enddatum einrichten.',
    [DelegationFormDialogTestIds.reasonInput]:
      'Optionaler Grund für die Delegierung — wird Genehmigern angezeigt und im Audit-Protokoll erfasst.',
    [DelegationFormDialogTestIds.workflowStepSelect]:
      'Delegierung auf einen bestimmten Genehmigungs-Workflow-Schritt einschränken — Standard belassen, um alle Genehmigungen zu delegieren.',
  },
}
